import { useQuery } from "@apollo/client/react";
import { useEffect } from "react";
import type React from "react";
import type {
  MeQuery,
  MeQueryVariables,
} from "@/codegen/graphql/generated/graphql";
import { GET_ME_QUERY } from "@/codegen/graphql/queries/GetMe.query";
import { useAuthStore } from "@/stores/useAuth";
import { useFragment } from "@/codegen/graphql/generated";
import { UserFragment } from "@/codegen/graphql/fragments/User.fragment";

const UserInfosWatcher: React.FC = () => {
  const currentUser = useAuthStore((s) => s.currentUser);

  const { data: meData } = useQuery<MeQuery, MeQueryVariables>(GET_ME_QUERY, {
    skip: !currentUser?.id && !currentUser?.providers.length, // Only fetch when authenticated
  });

  useEffect(() => {
    if (meData?.me)
      useAuthStore.setState({
        currentUser: useFragment(UserFragment, meData.me),
      });
  }, [meData]);

  return null;
};

export default UserInfosWatcher;
